import { useQuery } from "@tanstack/react-query";
import { api, qs } from "../lib/api";
import { useDashboard } from "../pages/Dashboard";

/** A tab query keyed by the page filters. */
export function useTabQuery<T>(path: string) {
  const { filters } = useDashboard();
  return useQuery({ queryKey: [path, filters], queryFn: () => api<T>(`${path}${qs(filters)}`) });
}

export const monthLabel = (ym: string) => {
  const [y, m] = ym.split("-");
  return `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][Number(m) - 1]} ${y!.slice(2)}`;
};
